import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

export const DEFAULT_LABEL_COLOR = '#047857';

/**
 * Themed wrapper around the native `<input type="color">` so the brand swatch
 * matches the rest of the UI (accent-ring focus, oklch border, panel background)
 * while still giving the user the full OS-provided color wheel.
 *
 * The native input is visually hidden behind the swatch but still receives clicks
 * via `<label>` association, which is how the OS picker is opened with no JS.
 */
@Component({
  selector: 'app-label-color-picker',
  imports: [],
  template: `
    <label class="color-swatch" [style.background]="value()" [attr.aria-label]="ariaLabel()">
      <span class="color-swatch__ring" aria-hidden="true"></span>
      <input
        type="color"
        class="color-swatch__input"
        [value]="value()"
        (input)="onInput($any($event.target).value)"
      />
    </label>
  `,
  styleUrl: './label-color-picker.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabelColorPickerComponent {
  readonly value = input<string>(DEFAULT_LABEL_COLOR);
  readonly ariaLabel = input<string>('Selecionar cor da label');
  readonly valueChange = output<string>();

  protected onInput(value: string): void {
    this.valueChange.emit(value);
  }
}
